import "./services.css";
import Services1 from "../../assets/Services1.png";
import Icon1 from "../../assets/Icon1.png";
import { useMediaQuery } from "react-responsive";
import { PRIMARY_COLOR } from "../../shared/colors";

const dataServices = [
  { id: 1, descrip: "Cobertura amplia y distribución eficiente." },
  { id: 2, descrip: "Entrega rápida y seguimiento en tiempo real." },
  {
    id: 3,
    descrip: "Soluciones integrales desde el proveedor hasta el cliente final.",
  },
  { id: 4, descrip: "Estrategias de marketing con ejecución de excelencia." },
  { id: 5, descrip: "Análisis de datos e informes para potenciar ventas." },
  { id: 6, descrip: "Experiencia y confianza en el mercado." },
];
const Services = () => {
  const isMobile = useMediaQuery({ maxWidth: 1250 });

  return (
    <>
      {isMobile ? (
        <>
          <div className="services">
            <div className="content-mobile">
              <p className="services-title">
                ¿Qué nos hace diferentes a los demás?
              </p>
              <div className="services-items">
                  {dataServices.map((service) => (
                    <div key={service.id} className="services-item">
                      <div className="d-flex flex-row g-1 align-items-center">
                        <img
                          className="icon-service"
                          style={{ width: "50px", height: "40px" }}
                          src={Icon1}
                          alt=""
                        />
                        <p className="mb-0" style={{ color: PRIMARY_COLOR }}>
                          {service.descrip}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="services">
            <div className="services-content">
              <div className="services-content-l">
                <p className="services-title">
                  ¿Qué nos hace
                  <br />
                  diferentes a los demás?
                </p>
                <div className="services-items">
                  {dataServices.map((service) => (
                    <div key={service.id} className="services-item">
                      <div className="d-flex flex-row g-1 align-items-center">
                        <img
                          className="icon-service"
                          style={{ width: "50px", height: "40px" }}
                          src={Icon1}
                          alt=""
                        />
                        <p className="mb-0" style={{ color: PRIMARY_COLOR }}>
                          {service.descrip}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="services-content-r">
                <img src={Services1} alt="" />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Services;
